import api from './index';
let exports = {};

//------------------商户物流公司----------------------
//查询列表
exports.getMerchantLogisComList = function (data, callback) {// 获取商户物流公司列表
    api.post('/merchtLogis/com/list/get')
    .data(data)
    .done(callback)
    .go();
};
//保存
exports.saveMerchantLogisCom = function (postData, callback) {// 保存商户物流公司
    api.post('/merchtLogis/com/save/do')
    .data(postData)
    .done(callback)
    .go();
};
//删除物流公司
exports.deleteMerchantLogisCom = function (data, callback) {// 刪除商户物流公司
    api.post('/merchtLogis/com/delete/do')
    .data(data)
    .done(callback)
    .go();
};
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/merchtLogis.js
// module id = 246
// module chunks = 0